"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SavedPlaidDepositPreparationState = void 0;
var SavedPlaidDepositPreparationState;
(function (SavedPlaidDepositPreparationState) {
    SavedPlaidDepositPreparationState["ready"] = "ready";
    SavedPlaidDepositPreparationState["pending"] = "pending";
    SavedPlaidDepositPreparationState["reconnectRequired"] = "reconnectRequired";
})(SavedPlaidDepositPreparationState || (exports.SavedPlaidDepositPreparationState = SavedPlaidDepositPreparationState = {}));
